import { FC } from 'react';
import { GroupsRounded } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import './TeamErrorStateCard.scss';

interface TeamErrorStateCardProps {
  message: string;
  showBackToTeams: boolean;
  onBackToTeams: () => void;
}

const TeamErrorStateCard: FC<TeamErrorStateCardProps> = ({
  message,
  showBackToTeams,
  onBackToTeams,
}) => {
  const { t } = useTranslation();

  return (
    <div className="team-error-state-card team-card team-card--state">
      <div className="team-page__logo-tile">
        <GroupsRounded />
      </div>
      <Typography variant="h2" component="h1" className="team-page__title">
        {t('team.error.couldNotLoadTeams')}
      </Typography>
      <Typography variant="body2" component="p" className="team-page__subtitle">
        {message}
      </Typography>
      {showBackToTeams && (
        <div className="team-page__actions team-page__actions--start">
          <Button
            type="button"
            variant="contained"
            color="primary"
            className="team-page__button team-page__button--primary"
            onClick={onBackToTeams}
          >
            <Typography variant="body1" component="span">
              {t('team.error.backToTeams')}
            </Typography>
          </Button>
        </div>
      )}
    </div>
  );
};

export default TeamErrorStateCard;
